/* eslint-disable */
import { sendbug } from '../../../app/util/net';
import StackTrace from 'stacktrace-js'

window.__EXCEPTIONTRACE__ = window.__EXCEPTIONTRACE__ ? window.__EXCEPTIONTRACE__ : [];

function pushStack(stack,excetionEvent,message){
  window.__EXCEPTIONTRACE__.push(
    {
      message,
      lastStates: '',
      error: {
        message: excetionEvent.reason ? excetionEvent.reason.message : JSON.stringify(excetionEvent),
        stack,
      },
    }
  );
  sendbug();
}
export function stackToString(stackframes){
  return stackframes.map(sf=> sf.toString()).join('\r\n');
}

window.addEventListener('unhandledrejection', function (event){
  if (window.__EXCEPTIONTRACE__) {
    let reasonStack;
    if (event.reason && event.reason.stack){

      StackTrace.fromError(event.reason)
        .then(
          mappedStack => pushStack(stackToString(mappedStack),event,'Unhandled promise rejection'),
          () => pushStack('no information',event,'Unhandled promise rejection')
        )
        .catch(
          () => pushStack('no information',event,'Unhandled promise rejection')
        )

    } else {
      pushStack('no information',event,'Unhandled promise rejection')
    }
  }
});

window.addEventListener('handledrejection', function (event){
  if (window.__EXCEPTIONTRACE__) {
    let reasonStack;

    if (event.reason && event.reason.stack) {

      StackTrace.fromError(event.reason)
        .then(
          mappedStack => pushStack(stackToString(mappedStack),event,'Handled promise rejection'),
          () => pushStack('no information',event,'Handled promise rejection')
        )
        .catch(
          () => pushStack('no information',event,'Handled promise rejection')
        )

    } else {
      pushStack('no information',event,'Handled promise rejection')
    }
  }
});
